import React from "react";
import { Link } from "react-router-dom";
import { ShieldCheck, Lock, Eye, Users } from "lucide-react";
import InfoLayout, { Sec } from "@/components/InfoLayout";
import { Button } from "@/components/ui/button";

export default function About() {
  return (
    <InfoLayout
      title="About CiteQR"
      subtitle="An institution-neutral platform that helps academics and professionals create reliable QR codes and shareable reference pages."
    >
      <Sec heading="Our purpose">
        <p>
          CiteQR helps students, researchers, faculty, healthcare professionals, educators, and conference presenters
          connect their audiences to the research behind their work. Whether it's a poster, a presentation, a survey,
          or a reading list, CiteQR turns academic materials into accessible, presentation-ready QR codes.
        </p>
      </Sec>
      <Sec heading="What makes us different">
        <ul className="space-y-3">
          <li className="flex items-start gap-3"><Lock className="mt-0.5 h-5 w-5 shrink-0 text-[#0D9488]" /><span><strong>Static, reliable codes.</strong> Codes encode the destination directly — no redirect servers, no expiry, no hidden tracking.</span></li>
          <li className="flex items-start gap-3"><Eye className="mt-0.5 h-5 w-5 shrink-0 text-[#0D9488]" /><span><strong>Verified readability.</strong> We check contrast and decode every code before you download it.</span></li>
          <li className="flex items-start gap-3"><ShieldCheck className="mt-0.5 h-5 w-5 shrink-0 text-[#0D9488]" /><span><strong>Privacy-first.</strong> Guest QR codes are generated in your browser and never stored on our servers.</span></li>
          <li className="flex items-start gap-3"><Users className="mt-0.5 h-5 w-5 shrink-0 text-[#0D9488]" /><span><strong>Institution-neutral.</strong> Designed for a clean, credible, professional academic experience.</span></li>
        </ul>
      </Sec>
      <Sec heading="A note on trust">
        <p>
          CiteQR does not claim HIPAA, FERPA, GDPR, or institutional compliance. Please do not upload confidential,
          sensitive, or identifiable patient, participant, or student information. We can't guarantee that an external
          website or document you link to will remain online permanently.
        </p>
      </Sec>
      <div className="flex flex-wrap gap-3 pt-2">
        <Button asChild className="bg-[#0D9488] text-white hover:bg-[#0F766E]"><Link to="/generator">Create Your QR Code</Link></Button>
        <Button asChild variant="outline"><Link to="/contact">Contact us</Link></Button>
      </div>
    </InfoLayout>
  );
}
